import {ConnectorGenericOutputStructureType} from "../../types";

export const CONNETTORI_INPUT_TYPES = [
  "geometria",
  "rinforzo",
  "carichi",
];

export const CONNETTORI_OUTPUT_STRUCTURE: Record<string, ConnectorGenericOutputStructureType> = {
  MasonryMaterialProperties: {
    type: "object",
    fields: {
      fhm: {type: "field"},
      FC: {type: "field"},
      gamma: {type: "field"},
      w: {type: "field"},
    },
  },
  MasonryWallProperties: {
    type: "object",
    fields: {
      Le: {type: "field"},
      B: {type: "field"},
      hup: {type: "field"},
      hbot: {type: "field"},
    },
  },
  StaticLoads: {
    type: "object",
    fields: {
      Gk1_Gk2: {type: "field"},
      Qk: {type: "field"},
      psi: {type: "field"},
      code: {type: "field"},
    },
  },
  SeismicLoads: {
    type: "object",
    fields: {
      ag: {type: "field"},
      S: {type: "field"},
      q0: {type: "field"},
    },
  },
  ReinforcementSlabCoreMaterial: {
    type: "object",
    fields: {
      Type: {type: "field"},
      fcd: {type: "field"},
      fftud: {type: "field"},
    },
  },
  ReinforcementCurbMaterial_compression: {
    type: "object",
    fields: {
      Type: {type: "field"},
      fd: {type: "field"},
    },
  },
  ReinforcementCurbMaterial_tension: {
    type: "object",
    fields: {
      Type: {type: "field"},
      fd: {type: "field"},
    },
  },
  ReinforcementShearConnectors: {
    type: "object",
    fields: {
      Type: {type: "field"},
      Vrd: {type: "field"},
    },
  },
  ReinforcementSlabProperties: {
    type: "object",
    fields: {
      hs: {type: "field"},
      AsAddRebars: {type: "field"},
    },
  },
  ResultsActions: {
    type: "object",
    fields: {
      fk1: {type: "field"},
      fk2: {type: "field"},
      fi: {type: "field"},
      ftot: {type: "field"},
      R: {type: "field"},
      M: {type: "field"},
      T: {type: "field"},
      Fc: {type: "field"},
      q: {type: "field"},
    },
  },
  ResultsChecks: {
    type: "object",
    fields: {
      C1: {type: "field"},
      C2: {type: "field"},
      C3: {type: "field"},
      T2: {type: "field"},
      T2rd: {type: "field"},
      Crd: {type: "field"},
      T1: {type: "field"},
      T1rd_c: {type: "field"},
      T1rd_T: {type: "field"},
      q: {type: "field"},
      s: {type: "field"},
    },
  },
};